import { render, staticRenderFns } from "./RiskAnalysisSummaryCard.vue?vue&type=template&id=3e4808c2&scoped=true"
import script from "./RiskAnalysisSummaryCard.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisSummaryCard.vue?vue&type=style&index=0&id=3e4808c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4808c2",
  null
  
)

export default component.exports